import { Button, Table } from '@dixa/lib-shared-habla';
import { AsyncStatus } from 'lib-shared-legacy-types';

import { TableLoadingRow } from 'components/shared/tableLoadingRow';

type Props = {
  readonly asyncStatus: AsyncStatus;
  readonly onRefreshItems: () => void;
};

const columnCount = 3;

export function LoadingRow({
  asyncStatus,
  onRefreshItems,
}: Props): JSX.Element {
  return asyncStatus === 'failed' ? (
    <Table.Tr>
      <Table.Td colSpan={columnCount}>
        Something went wrong...
        <Button variant="tertiary" onClick={onRefreshItems}>
          Try again
        </Button>
      </Table.Td>
    </Table.Tr>
  ) : (
    <TableLoadingRow colSpan={columnCount} />
  );
}
